import { Link } from "react-router-dom";

const OutstandingCourses = ({ courses, showTitle = true, limit = null }) => {
  const displayCourses = limit ? courses.slice(0, limit) : courses;

  return (
    <div className="py-16 px-4 md:px-6 lg:px-24">
      {showTitle && (
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B1B1B] mb-4">
            Our Outstanding <span className="text-[#FF4B01]">ICT Courses</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Our courses are built to spark creativity, boost confidence, and
            teach real tech skills
          </p>
        </div>
      )}

      <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
        {displayCourses.map((course) => (
          <div
            key={course.id}
            className="bg-white border-2 border-[#EBEAED] rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
          >
            <div className="py-6 px-10">
              <h3 className="text-xl font-medium font-Outfit text-[#113296] mb-4 text-center">
                {course.title}
              </h3>

              <div className="mb-6">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-48 object-cover "
                />
              </div>

              <div className="flex justify-between items-center">
                <Link to={`/kids/${course.id}`}>
                  <button className="bg-[#FF4B01] hover:bg-orange-600 font-Outfit font-medium text-base text-white px-6 py-2 rounded-full  transition-colors duration-200">
                    Go to course
                  </button>
                </Link>
                <span className="text-[#1B1B1B] font-Outfit font-medium text-base">
                  {course.duration}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      {limit && courses.length > limit && (
        <div className="text-center mt-8">
          <Link to="/kids/all-courses">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors duration-200">
              See more
            </button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default OutstandingCourses;

// import { Link } from "react-router-dom";

// const OutstandingCourses = ({ courses, showTitle = true, limit = null }) => {
//   const displayCourses = limit ? courses.slice(0, limit) : courses;

//   return (
//     <div className="py-16 px-4 md:px-6 lg:px-8">
//       {showTitle && (
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
//             Our Outstanding <span className="text-orange-500">ICT Courses</span>
//           </h2>
//           <p className="text-gray-600 max-w-2xl mx-auto">
//             Our courses are built to spark creativity, boost confidence, and
//             teach real tech skills
//           </p>
//         </div>
//       )}

//       <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//         {displayCourses.map((course) => (
//           <div
//             key={course.id}
//             className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
//           >
//             <div className="p-6">
//               <h3 className="text-xl font-semibold text-blue-600 mb-4 text-center">
//                 {course.title}
//               </h3>

//               <div className="mb-6">
//                 <img
//                   src={course.image || "/placeholder.svg"}
//                   alt={course.title}
//                   className="w-full h-48 object-cover rounded-lg"
//                 />
//               </div>

//               <div className="flex justify-between items-center">
//                 <Link to={`/cephas-kids/${course.id}`}>
//                   <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors duration-200">
//                     Go to course
//                   </button>
//                 </Link>
//                 <span className="text-gray-600 text-sm">{course.duration}</span>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default OutstandingCourses;
